import React, { createContext, useCallback, useContext, useEffect, useState } from 'react'
import { getTokenList } from '../utils'
import { sortBy } from 'lodash'

const TokenListContext = createContext([])

function useTokenListContext() {
  return useContext(TokenListContext)
}

export function useTokenList() {
  const [list, { updateList }] = useTokenListContext()

  return {
    tokenList: list,
    updateList
  }
}

export default function Provider({ children }) {
  const [list, setList] = useState([])

  const updateList = useCallback(async () => {
    const incomingList = (await getTokenList()) || []
    incomingList.forEach(item => {
      item.address = item.address.toLowerCase()
    })
    setList(sortBy(incomingList, 'address'))
  }, [setList])

  useEffect(() => {
    updateList()
  }, [updateList])

  return <TokenListContext.Provider value={[list, updateList]}>{children}</TokenListContext.Provider>
}
